import { z } from 'zod'

export const idealoManagedShopIds = [101, 201, 202, 203] as const

export const idealoManagedShopSchema = z.union([
  z.literal(101),
  z.literal(201),
  z.literal(202),
  z.literal(203),
])
export type IdealoManagedShop = z.infer<typeof idealoManagedShopSchema>
export type IdealoManagedShopKey = `${IdealoManagedShop}`

export const idealoManagedShopKeys = idealoManagedShopIds.map(shopId => String(shopId) as IdealoManagedShopKey)

export const idealoModeSchema = z.enum(['single', 'dual'])
export type IdealoMode = z.infer<typeof idealoModeSchema>

export const idealoListingVisibilitySchema = z.enum(['show', 'hide'])
export type IdealoListingVisibility = z.infer<typeof idealoListingVisibilitySchema>

export const idealoMinPriceByShopSchema = z.object({
  '101': z.number().optional(),
  '201': z.number().optional(),
  '202': z.number().optional(),
  '203': z.number().optional(),
})
export type IdealoMinPriceByShop = z.infer<typeof idealoMinPriceByShopSchema>

export const idealoVisibilityOverrideByShopSchema = z.object({
  '101': idealoListingVisibilitySchema.optional(),
  '201': idealoListingVisibilitySchema.optional(),
  '202': idealoListingVisibilitySchema.optional(),
  '203': idealoListingVisibilitySchema.optional(),
})
export type IdealoVisibilityOverrideByShop = z.infer<typeof idealoVisibilityOverrideByShopSchema>

export const idealoShopSettingsSchema = z.object({
  enabled: z.boolean(),
  singleModeVisible: z.boolean(),
  singleModeVisibleIfOnlyOwnShop: z.boolean(),
})
export type IdealoShopSettings = z.infer<typeof idealoShopSettingsSchema>

export const idealoSettingsShopsSchema = z.object({
  '101': idealoShopSettingsSchema,
  '201': idealoShopSettingsSchema,
  '202': idealoShopSettingsSchema,
  '203': idealoShopSettingsSchema,
})
export type IdealoSettingsShops = z.infer<typeof idealoSettingsShopsSchema>
